import { useState } from 'react';
import { useApp } from '../AppContext';
import { sendMagicLink } from '../firebase';
import './Auth.css';

// Three internal steps:
// 'email'   → user enters name + email
// 'sent'    → waiting screen after link is sent
// 'error'   → something went wrong

export default function Auth() {
  const { setScreen, authMode, showToast } = useApp();
  const [step, setStep] = useState('email');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (authMode === 'signup' && !name.trim()) { showToast('Please enter your name'); return; }
    if (!email.trim() || !email.includes('@')) { showToast('Please enter a valid email'); return; }

    setLoading(true);
    try {
      // Store name for after they return via the magic link
      if (name.trim()) window.localStorage.setItem('mercyNameForSignIn', name.trim());
      await sendMagicLink(email.trim());
      setStep('sent');
    } catch (err) {
      console.error(err);
      showToast('Could not send link. Try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth">
      <button
        className="auth-back"
        onClick={() => step === 'sent' ? setStep('email') : setScreen('onboard')}
      >
        ←
      </button>

      {step === 'email' && (
        <form className="auth-form" onSubmit={handleSubmit}>
          <h1 className="auth-title">
            {authMode === 'signup' ? 'Create your account' : 'Welcome back'}
          </h1>
          <p className="auth-sub">
            {authMode === 'signup'
              ? 'Your name will appear when your circle sees you tonight.'
              : 'Enter your email and we\'ll send you a sign-in link.'}
          </p>

          {authMode === 'signup' && (
            <div className="auth-field">
              <label className="input-label">Your name</label>
              <input
                className="input-field"
                type="text"
                placeholder="How your circle knows you"
                autoComplete="name"
                value={name}
                onChange={e => setName(e.target.value)}
              />
            </div>
          )}

          <div className="auth-field">
            <label className="input-label">Email address</label>
            <input
              className="input-field"
              type="email"
              placeholder="your@email.com"
              autoComplete="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
          </div>

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Sending...' : 'Send sign-in link'}
          </button>
        </form>
      )}

      {step === 'sent' && (
        <div className="auth-form">
          <div className="sent-icon">✉️</div>
          <h1 className="auth-title">Check your email</h1>
          <p className="auth-sub">
            We sent a sign-in link to{' '}
            <span className="auth-email-highlight">{email}</span>.
            Tap the link in that email to enter Mercy.
          </p>
          <div className="sent-note">
            The link expires in 1 hour. Check your spam folder if you don't see it.
          </div>
          <button
            className="btn btn-secondary"
            style={{ marginTop: 8 }}
            onClick={async () => {
              setLoading(true);
              try {
                await sendMagicLink(email.trim());
                showToast('Link resent');
              } catch {
                showToast('Could not resend. Try again.');
              } finally {
                setLoading(false);
              }
            }}
            disabled={loading}
          >
            {loading ? 'Sending...' : 'Resend link'}
          </button>
        </div>
      )}
    </div>
  );
}
